import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPE_UNITS_GET } from 'api/utilityActionTypes';

// Live fetch of a housing type's addresses (paginated; unitTypeName omitted = untyped
// bucket). The queryId includes type + offset so concurrent expands of different rows
// aren't deduped against each other by postWithState.
export default async function getRentManagerUnitTypeUnits(
  { state, utilityApiClient },
  { utilityPartnerId, unitTypeName, offset, limit, onSuccess, onError },
) {
  typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPE_UNITS_GET,
    queryId: `${utilityPartnerId}:${unitTypeName ?? '__untyped__'}:${offset ?? 0}`,
    state: state,
    payload: {
      utilityPartnerId,
      unitTypeName,
      offset,
      limit,
    },
    onSuccess: onSuccess,
    onError: onError,
  });
}
